import { server } from '@/constants';

// Dev passes `redirect_uri` explicitly (each worktree's origin differs); deployed envs share one.
export const LOGIN_POST_URL = `${server}/auth/login${import.meta.env.DEV ? `?redirect_uri=${encodeURIComponent(window.location.origin)}` : ''}`;
